/* ============================================================
   Curious Cart — drawer open/close + AJAX add/change/remove.
   Uses Section Rendering API for the drawer markup; reads /cart.js
   for state and updates the header icon badge locally.
   ============================================================ */

(function () {
  'use strict';

  var DRAWER_SECTION = 'curious-cart-drawer';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  // ---- Section Rendering: refresh drawer markup ---------------------
  function fetchDrawerHtml() {
    // Cache-bust via timestamp + no-store to avoid edge caching of section render
    return fetch('/cart?sections=' + DRAWER_SECTION + '&_=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Cache-Control': 'no-cache', 'Pragma': 'no-cache' }
    })
      .then(function (r) { return r.json(); })
      .then(function (j) { return (j && j[DRAWER_SECTION]) || ''; });
  }

  function refreshDrawer(html) {
    var newDoc = new DOMParser().parseFromString(html, 'text/html');
    var newDrawer = newDoc.querySelector('#CuriousCartDrawer');
    var oldDrawer = $('#CuriousCartDrawer');
    if (!newDrawer || !oldDrawer) return;
    var wasOpen = oldDrawer.classList.contains('is-open');
    oldDrawer.innerHTML = newDrawer.innerHTML;
    if (wasOpen) oldDrawer.classList.add('is-open');
    attachDrawerHandlers();
  }

  // ---- Local cart-icon update from /cart.js data --------------------
  function refreshIcon(itemCount) {
    var btn = $('[data-curious-cart-toggle]');
    if (!btn) return;
    var badge = btn.querySelector('[data-curious-cart-count]');
    if (badge) {
      badge.textContent = itemCount;
      if (itemCount > 0) badge.removeAttribute('hidden');
      else badge.setAttribute('hidden', '');
    }
    btn.setAttribute('aria-label', 'Open cart, ' + itemCount + ' ' + (itemCount === 1 ? 'item' : 'items'));
  }

  // Refresh both — drawer markup + icon count.
  function refreshAll() {
    return Promise.all([
      fetchDrawerHtml(),
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
    ]).then(function (results) {
      refreshDrawer(results[0]);
      refreshIcon(results[1].item_count);
    });
  }

  // ---- Drawer open/close --------------------------------------------
  function openDrawer() {
    var d = $('#CuriousCartDrawer');
    if (!d) return;
    d.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    document.body.classList.add('curious-cart-open');
  }
  function closeDrawer() {
    var d = $('#CuriousCartDrawer');
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('curious-cart-open');
  }

  function attachDrawerHandlers() {
    var d = $('#CuriousCartDrawer');
    if (!d) return;

    $$('[data-curious-cart-close]', d).forEach(function (b) {
      b.addEventListener('click', closeDrawer);
    });
    var ov = $('[data-curious-cart-overlay]', d);
    if (ov) ov.addEventListener('click', closeDrawer);

    $$('[data-curious-cart-step]', d).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(btn.getAttribute('data-line'), 10);
        var step = parseInt(btn.getAttribute('data-curious-cart-step'), 10);
        var input = d.querySelector('[data-curious-cart-qty][data-line="' + line + '"]');
        if (!input) return;
        var qty = Math.max(0, (parseInt(input.value, 10) || 0) + step);
        input.value = qty;
        changeLine(line, qty);
      });
    });

    $$('[data-curious-cart-qty]', d).forEach(function (input) {
      input.addEventListener('change', function () {
        var line = parseInt(input.getAttribute('data-line'), 10);
        var qty = Math.max(0, parseInt(input.value, 10) || 0);
        changeLine(line, qty);
      });
    });

    $$('[data-curious-cart-remove]', d).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(btn.getAttribute('data-line'), 10);
        changeLine(line, 0);
      });
    });

    $$('[data-curious-protection-toggle]', d).forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        btn.disabled = true;
        var isOn = btn.classList.contains('is-on');
        // Optimistic UI flip for snappy feedback
        btn.classList.toggle('is-on');
        var done = function () { btn.disabled = false; };
        if (isOn) {
          var line = parseInt(btn.getAttribute('data-sp-line'), 10);
          if (line) {
            changeLine(line, 0).then(done).catch(function () { btn.classList.toggle('is-on'); done(); });
          } else { done(); }
        } else {
          var vid = btn.getAttribute('data-sp-variant');
          var fd = new FormData();
          fd.append('id', vid);
          fd.append('quantity', '1');
          addToCart(fd)
            .then(function () { return refreshAll(); })
            .then(done)
            .catch(function () { btn.classList.toggle('is-on'); done(); });
        }
      });
    });
  }

  // Esc closes
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var d = $('#CuriousCartDrawer');
      if (d && d.classList.contains('is-open')) closeDrawer();
    }
  });

  function attachIconHandler() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-curious-cart-toggle]');
      if (!btn) return;
      e.preventDefault();
      openDrawer();
    });
  }

  // ---- AJAX cart operations -----------------------------------------
  function changeLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return refreshAll().then(function () { return cart; });
      });
  }

  function addToCart(formData) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: formData
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    });
  }

  // ---- Product form interception ------------------------------------
  function attachProductFormHandler() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('[data-curious-form]')) return;
      e.preventDefault();
      var btn = form.querySelector('[data-curious-add]');
      var label = form.querySelector('[data-curious-add-label]');
      var prevLabel = label ? label.textContent : '';
      if (btn) btn.disabled = true;
      if (label) label.textContent = 'Adding…';

      addToCart(new FormData(form))
        .then(function () { return refreshAll(); })
        .then(function () {
          openDrawer();
          if (label) label.textContent = 'Added ✓';
          setTimeout(function () {
            if (label) label.textContent = prevLabel || 'Add to cart';
            if (btn) btn.disabled = false;
          }, 1200);
        })
        .catch(function (err) {
          console.error('[curious-cart] add failed', err);
          if (label) label.textContent = err && err.description ? String(err.description).slice(0, 40) : 'Could not add';
          setTimeout(function () {
            if (label) label.textContent = prevLabel || 'Add to cart';
            if (btn) btn.disabled = false;
          }, 2000);
        });
    });
  }

  // ---- Init ---------------------------------------------------------
  function init() {
    attachDrawerHandlers();
    attachIconHandler();
    attachProductFormHandler();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.CuriousCart = { open: openDrawer, close: closeDrawer, refresh: refreshAll };
})();
